export default function patchFetchForSentryTrace(Sentry) {
  if (window._patchedFetch) {
	return;
  }
  // Save the original fetch
  const originalFetch = window.fetch;

  window.fetch = function (input, init = {}) {
	let url;

	if (typeof input === "string") {
	  url = input;
	} else if (input instanceof Request) {
	  url = input.url;
	} else {
	  throw new Error("Unsupported fetch input type");
	}
	
	const isSameOrigin = new URL(url, window.location.origin).origin === window.location.origin;

	if (isSameOrigin) {
	  const traceData = Sentry.getTraceData();
	  init.headers = {
		...init.headers,
		"sentry-trace": window.SENTRY_TRACE,
		baggage: window.SENTRY_BAGAGGE,
	  };
	}

	window._patchedFetch = true;
	return originalFetch(input, init);
  };
}
